/**
 * Privacy-safe analytics for ClientFlow SEO landing pages.
 *
 * Why a separate helper:
 *  - All capture calls are wrapped in try/catch so analytics failures never
 *    break the page.
 *  - We only pass non-PII properties: slug, path, page_title, and a CTA
 *    placement label. Never e-mail, phone, name, or any customer field.
 *  - PostHog is initialised globally in public/index.html, so this file
 *    just talks to `window.posthog` if it exists.
 *
 * Scope: only invoked from SEO landing pages. The booking flow, dashboard,
 * login and other app routes are not touched.
 */

function safeCapture(event, props) {
  try {
    if (
      typeof window !== "undefined" &&
      window.posthog &&
      typeof window.posthog.capture === "function"
    ) {
      window.posthog.capture(event, props);
    }
  } catch {
    /* analytics must never throw into UX */
  }
}

/**
 * Fires once per SEO landing page mount.
 *   props = { slug, path, page_title }
 */
export function trackSeoLandingView(props) {
  safeCapture("seo_landing_view", props);
}

/**
 * Fires when the user clicks a CTA on an SEO landing page.
 *   props = { slug, path, cta, placement }
 *   - cta:       "book_demo" | "see_prices" | "login" | "back_home"
 *   - placement: "nav" | "hero" | "final" | "footer"
 */
export function trackSeoLandingCta(props) {
  safeCapture("seo_landing_cta_click", props);
}
